import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, TrendingUp } from 'lucide-react';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    setIsVisible(true);
    
    // Parallax effect on scroll
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="home" className="relative min-h-screen pt-20 overflow-hidden">
      {/* Full-width Background Image with Parallax and Ken Burns effect */}
      <div className="absolute inset-0">
        <div 
          className="w-full h-full overflow-hidden"
          style={{
            transform: `translateY(${scrollY * 0.5}px)`,
          }}
        >
          <img
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80"
            alt="Professional Corporate Buildings"
            className="w-full h-full object-cover animate-ken-burns"
          />
        </div>
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d6571]/95 via-[#0d6571]/85 to-[#0d6571]/70"></div>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10 min-h-screen flex items-center">
        <div className="max-w-7xl mx-auto px-6 py-20 w-full">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left side - empty for image visibility */}
            <div></div>

            {/* Right side - Content */}
            <div
              className={`transition-all duration-1000 transform ${
                isVisible ? 'translate-x-0 opacity-100' : 'translate-x-20 opacity-0'
              }`}
            >
              <div className="mb-6">
                <div className="flex items-center gap-3 mb-6">
                  <TrendingUp className="w-12 h-12 text-[#d97841]" />
                  <div className="h-1 w-20 bg-[#d97841]"></div>
                </div>
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
                  The world changes faster
                </h1>
              </div>

              <p className="text-xl md:text-2xl text-white/90 leading-relaxed mb-8">
                Navigate the evolving landscape of global markets, digital payments, and sustainable investing with expert insights.
              </p>

              <p className="text-lg text-white/80 mb-10">
                Invest in yourself first. Improve your business model and broaden your knowledge before you step into the future.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  className="bg-[#d97841] hover:bg-[#d97841]/90 text-white border-none rounded-full px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 group"
                >
                  Get Started
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-white/50 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
